<template>
    <div class="c2-task-main" v-if="bodyShow">
        <h2>{{title}}</h2>
        <public-dialogue v-if="data.testid&&data.testid != 0" :testid="data.testid" :cid="$route.query.cid" :taskid="$route.query.id"></public-dialogue>
        <div v-for="(item,index) in list" :key="index">
            <!--  -->
            <div v-if="item.type == 'title'" :style="{marginTop:item.config.top/2+'px'}" class="c2-task-group">
                <!-- 处理字体颜色  -----参数:标题、需要变色的文字、颜色值、说明 -->
                <h3  v-html="doFontColor(item.label,item.config)"></h3>
            </div>
            <div v-if="item.type == 'evaluation'" :style="{marginTop:item.config.top/2+'px'}" class="c2-task-group holland">
                <!-- 类型 -->
                <h3 v-html="doFontColor(item.label,item.config)"></h3>
            </div>
            <!-- text -->
            <div v-if="item.type=='text'" :style="{marginTop:item.config.top/2+'px'}" :class="['c2-task-group text',item.config.select?'on':'']">
                <h3 v-html="doFontColor(item.label,item.config)"></h3>
                <div class="task-group-text">
                    <textarea class="c2-textarea" @input="textareaChange(index,item.content,item.id,item.config.word)" v-model="item.content" :placeholder="item.config.placeholder" ></textarea>
                    <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
                </div>
                <div v-if="item.config.select" class="c2-select-group">
                    <span  class="c2-select" @click="showSelectPoup(item.config.select.content,index,item.id)">
                        <span :class="['placeholder',item.selectVal?'on':'']"  v-html="item.selectVal?item.selectVal:item.config.select.placeholder"></span>
                        <img src="../../../assets/bottom.png" alt="">
                    </span>
                </div>
            </div>
            <!-- textarea -->
            <div v-if="item.type == 'textarea'" :style="{marginTop:item.config.top/2+'px'}" class="c2-task-group">
                <h3  v-html="doFontColor(item.label,item.config)"></h3>
                <div class="task-group-text">
                    <textarea class="c2-textarea" @input="textareaChange(index,item)" v-model="item.content" :placeholder="item.config.placeholder" ></textarea>
                    <span class="c2-word-limit">{{item.content?item.content.length:0}}/{{item.config.word}}</span>
                </div>
                <small class="small" v-if="item.config.subtitle"><span>*</span>{{item.config.subtitle.text}}</small>
            </div>
            <!-- subtitle -->
            <div v-if="item.type == 'subtitle'" :style="{marginTop:item.config.top/2+'px'}" class="c2-task-group subtitle">
                <h3  v-html="doFontColor(item.label,item.config)"></h3>

            </div>
        </div>
        <!-- 引入项目攻略入口 -->
        <task-strategy :cid="$route.query.cid" :pid="$route.query.pid"></task-strategy>
        <!-- submit -->
        <button  :class="['c-submit',bool?'on':'']" @click="submithandle()">提交</button>
        <!-- 难词 -->
		<van-popup class="explain" v-model="explain">
			<div>
				<h2>{{explain_difficult.title}}</h2>
				<p class="pps" v-html="explain_difficult.content"></p>
			</div>
		</van-popup>
        <!-- 删除弹窗 -->
        <van-popup class="pub_alert" v-model="deletePopup">
            <div class="confirm_box">
                <h2>是否确认删除？</h2>
                <div class="btn_group">
                    <a class="confirm on" href="javascript:;" @click="removeActionHandle">确认</a>
                    <a class="cancel" href="javascript:;" @click="deletePopup=false">取消</a>
                </div>
            </div>
        </van-popup>
        <!-- 第0期提示更新任务 -->
        <van-popup class="c2-task-pop" v-model="tips">
			<div>
				<p class="pps" v-html="data.tips"></p>
			</div>
		</van-popup>
        <!-- 显示下拉框内容 -->
        <van-popup position="bottom" v-model="showSelect">
            <van-picker show-toolbar :columns="columnsList" @cancel="showSelect=false" @confirm="selectChange" />
        </van-popup>
    </div>
</template>

<script>
import { index, subtable } from "@/api/course"
import { taskGlossary } from "@/api/course2"
import { getStorage, setStorage } from "@/utils/tools"
import { shareCon } from "@/utils/wxconfig"
import TaskStrategy from "@c/course/task-strategy"
export default {
    data() {
        return{
            bodyShow:false,
            data:{},
            title:'',
            list:[],
            userfield:[],
            bool:true,
            word_num:0,
            // 难词
            difficult:[],
            explain:false,
            explain_difficult:{
                title:'',
                content:''
            },
            difficult_text:'',
            deletePopup:false,
            // 判断是否是第0期
            tips:false,
            // 显示下拉数据
            showSelect:false,
            columnsList:[],
            showSelectIndex:null,
            showSelectId:null,
            interest_tendency:''
        }
    },
    components:{
        TaskStrategy
    },
    mounted(){
        window.difficultHandle = this.difficultHandle;
    },
    methods:{
        /*
         *@param: 
         *@return: 
         *@Description: 取出出现最多的元素(注：此方法暂未使用，保留处理)
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-11-29 18:13:56
        */
        appearMax(){
            let obj = {};
            let arr = [];
            let maxNum = 1;
            this.list.forEach((item,index)=>{
                // 判断是否有值
                if(item.selectVal){
                    // 判断对象属性是否存在
                    if(obj[item.selectVal]){
                        // 存在执行加一操作
                        obj[item.selectVal]+=1;
                    }else{
                        // 不存在，声明属性默认为1
                        obj[item.selectVal]=1;
                    }
                }
            });
            Object.keys(obj).forEach((m,i)=>{
                if(maxNum<=obj[m]){
                    if(arr.length>0 && maxNum!=obj[m]){
                        arr.splice(0,arr.length);
                    }
                    arr.push(m);
                    maxNum=obj[m];
                }
            });
            this.interest_tendency = arr;
        },
        /*
         *@Description: 改变下拉框值触发
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-11-29 16:26:10
        */
        selectChange(val){
            this.selectClickHandle(val,this.showSelectId)
            this.list[this.showSelectIndex]['selectVal'] = val;
            this.showSelect = false;
        },
        /*
         *@param: select下拉数据,index 下标
         *@return: 
         *@Description: 显示弹出层
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-11-29 16:21:52
        */
        showSelectPoup(select,index,id){
            this.showSelectId = id;
            this.showSelectIndex = index;
            this.columnsList = select;
            this.showSelect = true;
        },
        /*
         *@param:
         *@return:
         *@Description: 显示难词
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-22 11:03:19
        */
        difficultHandle(text){
            this.difficult.forEach((item,index)=>{
                if(item.name==this.b64Decode(text)){
                    this.explain_difficult.title =item.name;
                    // 替换空格和换行
                    this.explain_difficult.content =item.explain.replace(/\n/g,"<br/>").replace(/ /g,"&nbsp;");
                }
            });
            this.explain = true;
        },
        /*
         *@param:
         *@return:
         *@Description: 获取难词
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-10-22 10:23:01
        */
        getDifficultHandle(){
             // 获取难词
            taskGlossary({
                course_id:this.$route.query.cid,
                project_id: this.$route.query.pid,
                task_id: this.$route.query.id
            }).then((data)=>{
                if(data.code===10002){
                    this.$toast(data.data.msg);
                    return
                }
                // 取出难词difficult
                this.list.forEach((item,index)=>{
                    if(item.config &&item.config.difficult && Object.keys(item.config.difficult).length>0){
                        this.$forceUpdate();
                        for(let k=0;k<Object.keys(item.config.difficult).length;k++){
                            let nc = item.config.difficult[Object.keys(item.config.difficult)[k]];
                            if(data.list && data.list.length>0){
                                data.list.forEach((item2,index2)=>{
                                    if(item.config && nc.text==item2.word_name){
                                        this.difficult.push({
                                            name:item2.word_name,
                                            explain:item2.word_explain
                                        });
                                    }
                                });
                            }
                        }
                    }


                });
            });
        },
        // 转base64
        b64Encode(str) {
            return window.btoa(encodeURIComponent(str));
        },
        b64Decode(str) {
            return decodeURIComponent(window.atob(str));
        },
        // 改变字体颜色
        doFontColor(font,config){
            if(config && Object.keys(config).length>0){
                let select = (config.typeSet&& config.typeSet.text)?config.typeSet.text:'';
                let color = (config.typeSet&&config.typeSet.color)?config.typeSet.color:'';
                let small = (config.subtitle&& config.subtitle.text)?config.subtitle.text:'';
                let difficult_text = '';
                let difficult_arr = [];
                let bool = config.difficult && Object.keys(config.difficult).length>0;
                let bool2 = config.difficult && Object.keys(config.difficult).length>1;
                if(bool){
                    let arr = Object.keys(config.difficult);
                    if(bool2) {
                        for(let i =0;i<arr.length;i++){
                            this.$set(difficult_arr,i,config.difficult[arr[i]].text);
                        }
                    }else{
                        difficult_text = config.difficult[Object.keys(config.difficult)[0]].text;
                    }
                }
                if(select instanceof Array) {
                    select.forEach((item,idx)=>{
                        font = font.replace(item,(v)=>{
                            return `<span ${(bool||bool2)?'class=difficult-text':''} ${bool?(bool2?`onclick=difficultHandle('${this.b64Encode(difficult_arr[idx])}')`: `onclick=difficultHandle('${this.b64Encode(difficult_text)}')`):''}>${v.fontcolor(color)}</span>`
                        })+((config.subtitle && config.subtitle.position!='bottom')?"<span class='small'>"+small+"</span>":'');
                    });
                    return font;
                } else {
                    return font.replace(select,(v)=>{
                        return `<span ${(bool||bool2)?'class=difficult-text':''} ${bool?(bool2?`onclick=difficultHandle('${this.b64Encode(difficult_arr[idx])}')`: `onclick=difficultHandle('${this.b64Encode(difficult_text)}')`):''} >${v.fontcolor(color)}</span>`
                    })+((config.subtitle && config.subtitle.position!='bottom')?"<span class='small'>"+small+"</span>":'');
                }
            }else{
                 // small是括号里的说明
                return font;
            }

        },
        //改变输入框时触发------- 下标、内容、id、字数长度
        textareaChange(index,content,id,word){
            this.$forceUpdate();
            if(content && content.length > word) {
                this.$set(this.list[index],'content',content.slice(0, word));
		        this.$toast(`最多只能输入${word}个字。/(ㄒoㄒ)/~~`);
		    }else{
		    	setStorage(this.$route.path, 'id'+id, content);
            }
            this.validationHandle();
        },
        //改变选项-
        selectClickHandle(val,id){
            this.$forceUpdate();
		    setStorage(this.$route.path, id+'_'+'select', val);
            this.validationHandle();
        },
        pullData(){
            // loading
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            index({
                cid: this.$route.query.cid,
                cpid: this.$route.query.pid,
                cptid: this.$route.query.id
            })
            .then((data) => {
                this.$toast.clear();
                if(data.code===10002){
                    this.$toast(data.data.msg);
                    return
                }
                this.data = data;
                this.tips = data.tips?true:false;
                this.list = data.field.concat();
                this.userfield = data.userfield;
                document.title = this.$route.query.name;
                this.title = data.title;

                this.validationHandle(true);
                this.getDifficultHandle();
                this.bodyShow = true;
            })
        },
        validationHandle(bl){
            this.bool = true;
            if(this.list && this.list.length==0){
                this.bool = false;
                return
            }
            this.list.forEach((item,index)=>{
                // 判断是否是初始化
                if(bl){
                    // 判断是否已提交过数据
                    if(this.userfield && this.userfield.length>0){
                        this.userfield.forEach((item2,key)=>{
                            if(this.list[index].content){
                                return
                            }
                            if(item2.content && item2.field_id == this.list[index].id){
                                item.content = JSON.parse(item2.content).content?JSON.parse(item2.content).content:'';
                                item.selectVal = JSON.parse(item2.content).select?JSON.parse(item2.content).select:'';
                            }
                        });
                        if(!this.list[index].content) {
                            this.list[index].content = '';
                        }
                    }else{
                        let s = getStorage(this.$route.path, 'id'+item.id);
                        item.content = item.content?item.content:(s?s:'');
                        // 判断是否是单选
                        if(item.config && item.config.select&& Object.keys(item.config.select).length>0){
                            let storage = getStorage(this.$route.path, item.id+'_'+'select');
                            item.selectVal = item.selectVal?item.selectVal:(storage?storage:'');
                        }
                    }
                }
                // 判读是否有空
                if(item.type=='text' && (!item.content || item.content=='') || (item.config && item.config.select && !item.selectVal)){
                    this.bool=false;
                }

            })
        },
        submithandle(){
            if(this.bool){
                let arr = [];
                this.list.forEach((item,index)=>{
                    let content = {
                        content:item.content,
                        select:item.selectVal
                    };
                    if(item.content){
                        arr.push({
                            field_id:item.id,
                            content:JSON.stringify(content)
                        });
                    }
                });
                subtable({
                    cid:this.$route.query.cid,
                    form_id:this.list[0].form_id,//引入form_id都是一样的，所以取一个就可以
                    field:JSON.stringify(arr)
                }).then((data)=>{
                    this.$toast({
                        duration: 1000,
                        message: '提交成功！',
                        onClose:()=>{
                            this.$router.push({
                                path:'/project_report',
                                query:{
                                    cid:this.$route.query.cid,
                                    cpid:this.$route.query.pid,
                                    taskid: this.$route.query.id
                                }
                            });
                        }
                    });
                });
            }
        }
    },
    created(){
        this.pullData();
        shareCon("course2",this);
    }
}
</script>

<style lang="scss" scope>
    .c2-task-main{
        padding: 40px 30px 80px;
        text-align: center;
        h2{
            font-size: 36px;
            color: #333333;
            text-align: center;
            font-weight: bold;
        }
        .c2-task-group{
            position: relative;
            h3{
                text-align: left;
                font-size: 32px;
                color: #333333;
                span.small{
                    font-size: 28px;
                }
            }
            .c2-textarea{
                margin-top: 14px;
                height: 160px;
                border-radius: 8px;
                background-color: #fff;
                border: 0;
                width: 100%;
                padding: 22px 20px;
                font-size: 26px;
                resize:none;
                text-align: left;
            }
            .c2-word-limit{
                position: absolute;
                font-size: 18px;
                color: #999;
                bottom: 14px;
                right: 16px;
            }
        }
        .c2-select-group{
            margin-top: 14px;
            .c2-select{
                display: flex;
                align-items: center;
                line-height: 70px;
                height: 70px;
                background-color: #FFFFFF;
                border-radius: 8px;
                padding: 0px 20px;
                .placeholder{
                    color: #999;
                }
                .placeholder.on{
                    color: #333;
                }
                img{
                    width: 27px;
                    margin-left: auto;
                }
            }
        }
        .c2-task-group.text{
            h3{
                font-size: 28px;
                color: #333333;
            }
            .task-group-text{
                line-height: 1;
                position: relative;
            }
            .c2-textarea{
                height: 70px;
                line-height: 70px;
                padding: 0px 20px;
            }
        }
        .c2-task-group.holland {
            h3{
                color: #333333;
                line-height: 48px;
            }
        }
        .c2-task-group.subtitle h3{
            font-size: 24px;
        }
        .c-submit{
            width:174px;
            height:66px;
            background:#CCCCCC;
            border-radius:33px;
            font-size: 34px;
            color: #FFFFFF;
            border: 0;
            margin: 80px auto auto;
        }
        .c-submit.c-mr{
            margin-right: 80px;
        }
        .c-submit.on{
            background-color: #EA345C;
        }
        /* 难词弹窗 */
        .explain{
            width: 690px;
            padding: 40px 50px;
            border-radius:9px;
            text-align: left;
            h2{
                text-align: left;
                margin-top: 0;
                font-size: 32px;
                color: #EA345C;
                font-weight: normal;
                margin-bottom: 24px;
            }
            .pps{
                font-size: 26px;
                line-height:48px;
                color: #333;
                text-align: justify;
            }
        }
        //
        .c2-task-pop{
            width: 680px;
            padding: 40px 50px;
            border-radius:9px;
            text-align: left;
            .pps{
                font-weight: bold;
                font-size: 26px;
                line-height:48px;
                color: #333;
                text-align: justify;
            }
        }
        .difficult-text{
            text-decoration: underline;
        }
    }
body{
  background: #f0f0f0 !important;
}
</style>